import React from "react";
import PropTypes from "prop-types";

import styles from "./inforow.scss";

export default function InfoRow(props) {
    const { label, children } = props;
    return (
        <div className={styles.wrapper}>
            <div className={styles.label}>
                <span>{label}</span>
            </div>
            <div className={styles.value}>
                {children}
            </div>
        </div>
    );
};

InfoRow.propTypes = {
    label: PropTypes.string.isRequired
}
